import { GetStaticPaths, GetStaticProps, NextPage } from "next";
import { ListNews, PaginationPosts } from "../../../components";
import { PostItems } from "../../../types/PostsList";
import { NavigationTypes, NewsTypes } from "../../../types/HomeTypes";
import { FooterWidget, NewMenu } from "../../../types/Menu";
import { itemsMenuHierarch } from "../../../utils/menuHierarch";
import { executeQuery } from "../../../services/graphql";
import MainLayout from "../../../components/MainLayout";
import { CACHE_TIME_DEFAULT } from "../../../utils/requests";
import { getFooterMenu } from "../../../repositories/menu";
import { AllPosts } from "../../../graphql/allNews";
import { pagination } from "../../../utils/paginator";
import environment from "../../../config/environment";
import { PaginationQueryRequest } from "../../../services/graphql/types/paginationQuery";

interface PostsQueryResult {
  menu: Array<NewMenu>;
  edges: Array<PostItems>;
  categories: Array<NavigationTypes>;
  idPage: string | number;
  footerMenu: FooterWidget;
  UltimasNoticias404: Array<NewsTypes>;
  paginationNumbers: Array<number>;
}

const AllLastPosts: NextPage<PostsQueryResult> = ({
  menu,
  edges,
  categories,
  idPage,
  footerMenu,
  paginationNumbers,
}) => {
  return (
    <MainLayout
      customStyle={{ backgroundColor: "#f9f9f9" }}
      head={{ title: `Veja todos as postagens - Página: ${idPage}` }}
      headerMenu={menu}
      footerMenu={footerMenu}
    >
      <ListNews
        edges={edges}
        name={`Mais recentes`}
        navigation={categories}
        displayDescription={true}
      />
      <PaginationPosts
        items={paginationNumbers}
        link={`${environment.basePath}/page`}
        pageActive={Number(idPage)}
      />
    </MainLayout>
  );
};

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: [],
    fallback: "blocking",
  };
};

export const getStaticProps: GetStaticProps = async (context) => {
  const idPage = context.params.id as string;
  const sizeQtPosts = 30;
  const pageNumber = Number(idPage) - 1;
  const offsetItems = sizeQtPosts * pageNumber;

  const { data } = await executeQuery<PaginationQueryRequest>(AllPosts, {
    size: sizeQtPosts,
    offset: offsetItems,
  });

  const edges = data?.posts?.edges;
  const categories = data?.categories?.nodes;
  const totalItems = data?.posts?.pageInfo.offsetPagination.total;
  const menu = itemsMenuHierarch(data?.Head?.nodes[0]?.menuItems?.nodes);
  const footerMenu = await getFooterMenu();

  const totalPages = Math.ceil(totalItems / sizeQtPosts);
  const paginationNumbers = pagination(Number(idPage), totalPages);

  if (!data || edges.length == 0) {
    return { notFound: true };
  }

  return {
    props: {
      menu,
      edges,
      categories,
      idPage,
      footerMenu,
      paginationNumbers,
    },
    revalidate: CACHE_TIME_DEFAULT,
  };
};

export default AllLastPosts;
